export class CurrentEditors {
  constructor(
    public userName: string,
    public terminalName: string,
    public editStartDateTime: Date,
    public token: string,
  ) {
  }
}

